'use strict';
import {Sentry} from '../Core/sentry.js';
import './surveyapp.scss';
import {createRoot} from 'react-dom/client';
import React, {Suspense} from 'react';
import {LoadingScreen} from '../../UserInterfaces/AppInterface/elements/Loaders/LoadingScreen.js';
import SurveyApp from './SurveyApp.js';

Sentry.configureScope(scope => scope.setTag('interface', 'survey-app'));

const rootElement = createRoot(document.getElementById('app-root'));

rootElement.render(
    <Suspense fallback={
        <LoadingScreen/>}>
        <SurveyApp/>
    </Suspense>);
